import React from "react";
import { Link } from "react-router-dom";
import { formatMoney, timeAgo } from "@/lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const Chip = ({ children, tone = "default" }) => {
  const tones = {
    default: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
    accent: "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300",
    amber: "bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
    slate: "bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900",
  };
  return <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide ${tones[tone]}`}>{children}</span>;
};

export default function CompanyList({ companies }) {
  return (
    <div className="rounded-lg border border-border bg-card overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="bg-secondary/50 hover:bg-secondary/50">
            <TableHead className="w-[280px]">Company</TableHead>
            <TableHead>Industry</TableHead>
            <TableHead>Stage</TableHead>
            <TableHead className="text-right">Raise</TableHead>
            <TableHead>Revenue</TableHead>
            <TableHead className="text-center">EIS</TableHead>
            <TableHead className="text-center">SEIS</TableHead>
            <TableHead>Priority</TableHead>
            <TableHead>Updated</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {companies.map((c) => (
            <TableRow key={c.id} className="cursor-pointer" data-testid={`company-row-${c.id}`}>
              <TableCell>
                <Link to={`/companies/${c.id}`} className="flex items-center gap-3 group">
                  <div className="h-9 w-9 rounded bg-secondary overflow-hidden shrink-0">
                    {c.logo_url ? <img src={c.logo_url} alt="" className="h-full w-full object-cover" /> : <div className="h-full w-full grid place-items-center text-xs font-semibold">{c.name?.[0]}</div>}
                  </div>
                  <div className="min-w-0">
                    <div className="font-medium truncate group-hover:underline underline-offset-2">{c.name}</div>
                    <div className="text-xs text-muted-foreground truncate max-w-[220px]">{c.tagline}</div>
                  </div>
                </Link>
              </TableCell>
              <TableCell className="text-sm">{c.industry}</TableCell>
              <TableCell className="text-sm">{c.stage}</TableCell>
              <TableCell className="text-right num-display font-medium">{formatMoney(c.fundraising?.amount_raising)}</TableCell>
              <TableCell className="text-sm">{c.revenue_status}</TableCell>
              <TableCell className="text-center">{c.eis ? <Chip tone="accent">EIS</Chip> : <span className="text-muted-foreground">—</span>}</TableCell>
              <TableCell className="text-center">{c.seis ? <Chip tone="accent">SEIS</Chip> : <span className="text-muted-foreground">—</span>}</TableCell>
              <TableCell>
                <Chip tone={c.priority === "High" ? "amber" : "default"}>{c.priority}</Chip>
              </TableCell>
              <TableCell className="text-xs text-muted-foreground">{timeAgo(c.updated_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
